// Generate random string of letters
export default function generateLabel(prefix, isCopy = false) {
  if (isCopy) {
    let number = prefix.split("_")[1];
    isNaN(number) ? (number = 1) : number++;
    return prefix.split("_")[0] + "_" + number;
  } else {
    return (
      prefix.split("_")[0] +
      "_" +
      Array(4)
        .fill(null)
        .map(() => ((Math.random() * 100) % 25) + "A".charCodeAt(0))
        .map((a) => String.fromCharCode(a))
        .join("")
    );
  }
}
